import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"; // Import useLocation

const Card = ({
  imageSrc,
  title,
  badge,
  offered,
  purchased,
  productLink,
  cartLink,
  soldOut,
  productViews,
  reviewCount,
  averageRating,
  freeDelivery,
  productInventoryId,
}) => {
  const [badgeArray, setBadgeArray] = useState([]);
  const [currentBadgeIndex, setCurrentBadgeIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation(); // Get the current location

  useEffect(() => {
    if (badge) {
      setBadgeArray(badge.split(","));
    }
  }, [badge]);

  useEffect(() => {
    if (badgeArray.length > 1) {
      const interval = setInterval(() => {
        setIsAnimating(true);
        setTimeout(() => {
          setCurrentBadgeIndex(
            (prevIndex) => (prevIndex + 1) % badgeArray.length
          );
          setIsAnimating(false);
        }, 500);
      }, 3500);

      return () => clearInterval(interval);
    }
  }, [badgeArray]);

  const formatNumber = (number) => {
    if (number >= 1000) {
      return `${(number / 1000).toFixed(1)}k`;
    }
    return number;
  };

  const getDiscountPercentage = () => {
    if (!offered || !purchased) return 0;
    const discount = ((offered - purchased) / offered) * 100;
    return discount.toFixed(0);
  };

  const discountPercentage =
    offered !== purchased ? getDiscountPercentage() : purchased;

  // Check if the current location is not /product and /shop
  const showAddToCartBtn =
    location.pathname !== "/shop" && !location.pathname.includes("/product/");

  return (
    <div className="col-xxl-2 col-lg-3 col-sm-4 col-6 my-20 ">
      <div
        className="product-card w-100 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2 overflow-hidden"
        style={{
          minWidth: "17rem",
          minHeight: "20rem",
        }}
      >
        {/* Danger Badge for Sale */}
        {/* {discountPercentage > 0 && (
          <span
            className="product-card__badge z-index-3 position-absolute start-0 bg-danger-600 px-8 py-4 text-sm text-white"
            style={{
              borderRadius: "16px 0 16px 0",
            }}
          >
            Sale {discountPercentage}% OFF
          </span>
        )} */}
        <Link to={productLink} className="flex-center h-100 ">
          <div style={{ position: "relative", minWidth: "100%" }}>
            <img
              className="rounded-top-4 w-100 overflow-hidden transform transition"
              style={{
                width: "100%",
                height: "16rem",
                objectFit: "contain",
                transition: "transform 0.3s ease",
                overflow: "hidden",
              }}
              // src="assets/images/thumbs/test.avif"
              src={imageSrc}
              alt={title || "Product Image"}
              onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.1)")
              }
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            />

            {/* Conditionally render the Free Delivery badge */}
            {freeDelivery &&
              (freeDelivery === "FREE" || freeDelivery === "PARTIAL_FREE") && (
                <p
                  className="position-absolute bottom-0 start-0 end-0 text-center text-xs text-uppercase rounded-end"
                  style={{
                    backgroundColor: "#007c65", // Optional: to make the text stand out
                    color: "white", // Optional: change text color for contrast
                    margin: 0,
                    padding: "2px 0", // Optional: to give some spacing
                    maxWidth: "8.5rem",
                  }}
                >
                  <i
                    className="bi bi-truck fw-bold"
                    style={{ marginRight: "1px" }}
                  ></i>{" "}
                  {freeDelivery === "FREE"
                    ? "Free Delivery"
                    : "Free Delivery +1"}
                </p>
              )}
          </div>
        </Link>

        <div
          className="product-card__content p-10 d-flex flex-column"
          style={{ minHeight: "8rem", maxHeight: "8rem" }}
        >
          <h2 className="title text-md fw-semibold mb-2">
            <Link
              to={productLink}
              className="link text-line-2"
              style={{
                color: "inherit",
              }}
            >
              {title}
            </Link>
          </h2>

          <div className="d-flex justify-content-between align-items-center">
            <div className="product-card__price flex-between w-100">
              <div>
                <span
                  className=" text-md fw-semibold"
                  style={{ color: "#ff4c01" }}
                >
                  Rs.{purchased}
                </span>
                {offered !== purchased && (
                  <span className="text-muted-400 text-xs fw-semibold text-decoration-line-through mx-10">
                    Rs.{offered}
                  </span>
                )}
              </div>

              <div className="text-xs fw-bold text-gray-600">
                ({reviewCount || 0} reviews)
              </div>
            </div>
          </div>

          <div className="flex-between">
            <span className="text-xs text-gray-600">
              {soldOut > 9
                ? `${formatNumber(soldOut)} sold`
                : `${formatNumber(productViews || 0)} views`}
            </span>
            <div className="flex-center gap-2">
              <div className="flex-align gap-4">
                {/* Loop through 5 stars */}
                {(() => {
                  const rating = averageRating; // Example rating
                  const fullStars = Math.floor(rating); // Full stars
                  const hasHalfStar = rating % 1 >= 0.5; // Check for half star
                  const stars = [];

                  // Push full stars
                  for (let i = 0; i < fullStars; i++) {
                    stars.push("full");
                  }

                  // If there's a half star
                  if (hasHalfStar) {
                    stars.push("half");
                  }

                  // Fill the remaining stars with empty ones
                  while (stars.length < 5) {
                    stars.push("empty");
                  }

                  return stars.map((star, index) => (
                    <span
                      key={index}
                      className="text-12 --bs-warning fw-medium d-flex"
                    >
                      {/* Display full, half, or empty star */}
                      <i
                        className={`${
                          star === "empty"
                            ? "bi bi-star text-warning" // Empty star
                            : "bi bi-star-fill text-warning" // Full star with color
                        } ${
                          star === "half" ? "bi bi-star-half text-warning" : ""
                        }`}
                      />
                    </span>
                  ));
                })()}
              </div>
            </div>
          </div>

          {/* Conditionally Render the AddToCartBtn */}
          {showAddToCartBtn && (
            <div className="flex-between align-items-center ">
              <div className="text-sm overflow-hidden ">
                <div
                  style={{
                    transform: isAnimating
                      ? `translateY(-100%)`
                      : `translateY(0)`,
                    transition: "transform 0.5s ease",
                  }}
                >
                  <div className="flex-center gap-4 text-xs">
                    {badgeArray[currentBadgeIndex] ===
                      "Direct from wholeseller" && (
                      <img
                        style={{ maxWidth: "1rem" }}
                        src="/assets/images/icon/tick.png"
                        alt=""
                      />
                    )}
                    <p
                      style={{
                        color:
                          badgeArray[currentBadgeIndex] === " Almost sold out"
                            ? "#ff4c01"
                            : badgeArray[currentBadgeIndex] === "Best seller"
                            ? "gray"
                            : "black",
                      }}
                      className={
                        badgeArray[currentBadgeIndex] ===
                        "Direct from wholeseller"
                          ? "fw-bold"
                          : ""
                      }
                    >
                      {badgeArray[currentBadgeIndex]}
                    </p>
                  </div>
                </div>
              </div>
              <button
                className="product-card__cart opacity-0 px-16 py-4 text-main-600 hover-bg-main-600 hover-text-white rounded-pill flex-align border border-main-600 justify-content-center"
                disabled={true} // Always disable the button
              >
                {loading ? (
                  <i className="bi bi-spinner bi-spin" />
                ) : (
                  <i className="ph ph-shopping-cart" />
                )}
                {loading ? <i className="bi bi-arrow-repeat"></i> : ""}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Card;
